// TODO PP-16776: move LoggedInWeb/utils/user-action-channel here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/user-action-channel';
